module.exports = __webpack_public_path__ + "static/media/info-informationbutton.94ed7324.png";